import { Flex, Text } from "@aws-amplify/ui-react";

export default function InsuranceSectionContent({ insuranceData }) {
  return (
    <Flex gap="3px" direction="column">
      <Text
        fontFamily="Inter"
        children={`Provider: ${insuranceData?.providerName || ""}`}
      ></Text>
      <Text
        fontFamily="Inter"
        children={`Plan: ${insuranceData?.planName || ""}`}
      ></Text>
      <Text
        fontFamily="Inter"
        children={`Policy: ${insuranceData?.policyNumber || ""}`}
      ></Text>
    </Flex>
  );
}
